import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/AudioVideo";
import AudioVideoImg from "../assets/images/DeathModuleNew/QR Code.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import AddModal from "./styledComponents/Modal/AddModal";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import Input from "../components/styled-components/input/input";
import Loader from "../components/styled-components/loader/loader";
import fileIcon from "../assets/images/DeathModuleNew/Icons.png";
import { Button, Modal, Upload,Collapse,} from "antd";

import AudioReactRecorder, { RecordState } from "audio-react-recorder";
import RecordImg from "../assets/images/DeathModuleNew/Play button.png";
import { WebcamStreamCapture } from "./Recorder";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
// import img1 from "../assets/images/DeathModuleNew/leftcr1.png";
// import img2 from "../assets/images/DeathModuleNew/leftcr2.jpg";
// import img3 from "../assets/images/DeathModuleNew/leftcr3.png";
// import img4 from "../assets/images/DeathModuleNew/leftcr4.png";
// import img5 from "../assets/images/DeathModuleNew/leftcr5.png";
// import img6 from "../assets/images/DeathModuleNew/leftcr6.png";
// import img7 from "../assets/images/DeathModuleNew/leftcr7.jpg";
// import img8 from "../assets/images/DeathModuleNew/leftcr8.png";
// import img9 from "../assets/images/DeathModuleNew/leftcr9.png";
// import img10 from "../assets/images/DeathModuleNew/leftcr10.png";
import img1 from "../assets/images/audioVideo/left1.png";
import img2 from "../assets/images/audioVideo/left2.png";
import img3 from "../assets/images/audioVideo/left3.png";
import img4 from "../assets/images/audioVideo/left4.png";
import img5 from "../assets/images/audioVideo/left5.png";
import img6 from "../assets/images/audioVideo/left6.png";
import img7 from "../assets/images/audioVideo/left7.png";
import img8 from "../assets/images/audioVideo/left8.png";
import img9 from "../assets/images/audioVideo/left9.png";
import img10 from "../assets/images/audioVideo/left10.png";

import swal from "sweetalert";
import moment from "moment";
import axios from "axios";
import { AdsContainer } from "./AdsContainer";
import { CarouselContainer } from "./CarouselContainer";

export const AudioVideo = (props) => {
  const { Panel } = Collapse;

  const imageList = [
    {
      id: 1,
      fileName: img1,
      name: "Online Remote Therapy",
      href: "https://www.talkspace.com/",
    },
    {
      id: 2,
      fileName: img2,
      name: "Online Therapy",
      href: "https://www.betterhelp.com/ ",
    },
    {
      id: 3,
      fileName: img3,
      name: "Personal Psychology and Therapy",
      href: "https://www.psychologytoday.com/us/therapists/91361?category=online-counseling",
    },
    {
      id: 4,
      name: "Online Therapy Insurance Focused",
      fileName: img4,
      href: "https://www.teladoc.com/",
    },
  ];
  const imageList1 = [
    {
      id: 1,
      fileName: img5,
      name: "Healing Through Crafts",
      href: "https://www.pinterest.com/healingbrave/  ",
    },
    {
      id: 2,
      fileName: img6,
      name: "Famous People Delivering Custom Messages",
      href: "https://www.cameo.com/",
    },
    {
      id: 3,
      fileName: img7,
      name: "Words of Faithful Healing",
      href: "https://christian.net/resources/bible-verses-about-grief/",
    },

    {
      id: 4,
      fileName: img8,
      name: "Resources for Jewish Mourning",
      href: "https://www.shiva.com/learning-center/resources/poems-of-comfort",
    },
    {
      id: 5,
      name: "A Place of Communal Support",
      fileName: img9,
      href: "https://www.griefshare.org/ ",
    },
    {
      id: 6,
      fileName: img10,
      name: "Amazon Books on Grief",
      href: "https://www.amazon.com/Grief-Bereavement-Death-Books/b?ie=UTF8&node=4610",
    },
  ];

  const [recordState, setRecordState] = useState(null);
  const [audioData, setAudioData] = useState(null);
  const [showUploading, setShowUploading] = useState(false);
  const [currentType, setCurrentType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [audioVideo, setAudioVideo] = useState({});
  const [loading, setLoading] = useState(false);
  const [tooltipModal, setTooltipModal] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [uploaded, setUploaded] = useState(null);
  const [viewAudio, setViewAudio] = useState(false);
  const [viewVideo, setViewVideo] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [readMore, setReadMore] = useState(false);
  const [handleResouceVideoModal, setHandleResouceVideoModal] = useState(null);
  const extraContent = (
    <div>
      <p className="extra-content">
        Third-party professional services that are skilled in such important,
        yet delicate matters are available as part of our expanding service
        network. Plan Creators can also record these messages from any location
        they appreciate and can be uploaded at their convenience. Fun: Messages
        don’t need to be serious. They can also be fun and silly including the
        use of third-party provider cameo.com where celebrities and other people
        of interest leave custom messages for the departed and their target
        group. An extreme example: Can you imagine the sendoff message for a
        KISS superfan to have Gene Simmons say the words- “John Doe was a
        superfan he bought KISS condoms and KISS coffins, so we had him coming
        and going. He will truly be missed but he wants you to party all night
        at his funeral”.
      </p>
    </div>
  );

  const handleResourcesVideo = () => {
    setHandleResouceVideoModal(true);
  };

  const handleCancelResourcesVideo = () => {
    setHandleResouceVideoModal(false);
  };

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
    setReadMore(false);
  };
  useEffect(() => {
    getAudioVideo();
  }, []);
  const getAudioVideo = async () => {
    try {
      // this.props.handleLoader()
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      const data = await DEATH_API.fetchAudioVideo(ID);
      if (data && data.data) setAudioVideo(data.data);
      // this.setState({
      //   audio_video: data.data,
      // });
      // this.props.handleLoader()
      setLoading(false);
    } catch (error) {
      console.log(error);
      // this.props.handleLoader()
      setLoading(false);
    }
  };

  const HandleAudioUpload = async ({
    file,
    onError,
    onSuccess,
    onProgress,
  }) => {
    const fileSize = file.size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    if (fileSize < 100) {
      console.log("inside file size");
      setShowUploading(true);
      // this.setState({
      //   showUploading: true,
      // });
      setFileName(file.name);
      try {
        const formData = new FormData();
        console.log("file....", file);
        const name = file.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        setLoading(true);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: file.type,
        });
        const resupload = await axios.put(resdata.uploadUrl, file, {
          headers: { "Content-type": file.type },
          onUploadProgress: (event) => {
            const { total, loaded } = event;
            onProgress({ percent: Math.round((loaded / total) * 100) }, file);
          },
        });
        onSuccess(resupload);
        const res = resdata.uploadUrl.split("?")[0];
        console.log(res);

        let obj = {
          ...audioVideo,
          [currentType]: res,
          [currentType + "Date"]: new Date(),
        };
        setAudioVideo((prev) => ({
          ...prev,
          [currentType]: res,
          [currentType + "Date"]: new Date(),
        }));

        // this.setState({
        //   audio_video: {
        //     ...this.state.audio_video,
        //     [this.state.currentType]: res,
        //   },
        // });
        await updateRecord(obj);
        setRecordState(null);
        setFileName(null);
        setLoading(false);
        setShowModal(false);
        swal("Uploaded!", "Your file has been Uploaded.", "success");
        // e.onSuccess(res, e.file)
      } catch (error) {
        setLoading(false);
        onError(error);
        console.log(error);
      }
    } else {
      // this.setState({ showAudioModal: false });
      swal("Oops!", "File size is large! (Max allowed 100MB)", "error");
    }
  };
  const start = () => {
    setRecordState(RecordState.START);
  };

  const stop = () => {
    setRecordState(RecordState.STOP);
  };
  const onStop = async (audioData) => {
    console.log("audioData", audioData);
    setUploaded(audioData);
    // setAudioData(audioData);
    // this.setState({
    //   audioData: audioData,
    // });
    setLoading(true);
    console.log("audioData", audioData);
    var file = new File([audioData.blob], "recorded.mp3", {
      type: "audio/wav",
    });
    console.log("audio file", file);
    // this.setState({ isLoading: true })
    const resdata = await MODULE_API.uploadFile({
      fileExt: "mp3",
      contentType: "audio/wav",
    });
    setShowModal(false);

    const resupload = await axios.put(resdata.uploadUrl, file, {
      headers: { "Content-type": file.type },
    });

    const res = resdata.uploadUrl.split("?")[0];
    console.log("audio url ", res, currentType);
    // let obj={
    //   ...audioVideo
    // }
    let obj = {
      ...audioVideo,
      [currentType]: res,
      [currentType + "Date"]: new Date(),
    };
    setAudioVideo((prev) => ({
      ...prev,
      [currentType]: res,
      [currentType + "Date"]: new Date(),
    }));
    // setUploaded((prevFormData) => ({
    //   ...prevFormData,
    //   [currentType]: res,
    // }));
    // this.setState({ audio_video: { ...this.state.audio_video, [this.state.currentType]: res } })
    await updateRecord(obj);
    setLoading(false);

    // this.setState({ isLoading: false })
    setRecordState(null);
    // this.setState({ showAudioModal: false });
    swal("Uploaded!", "Your file has been Uploaded.", "success");
  };
  const updateRecord = async (obj) => {
    console.log("update record", obj);
    setLoading(true);
    await DEATH_API.updateAudioVideo({
      incapacitatedAudio: null,
      incapacitatedVideo: null,
      spouseVideo: null,
      spouseAudio: null,
      familyAudio: null,
      familyVideo: null,
      friendsVideo: null,
      friendsAudio: null,
      ...obj,
    });
    setLoading(false);
    getAudioVideo();
  };
  const handelCloseModal = () => {
    setShowModal(false);
  };
  const handelCloseVideoModal = () => {
    setShowVideoModal(false);
  };
  const handleChange = (obj) => {
    const { name, value } = obj;

    console.log("data", obj);
  };
  const submitData = () => {
    console.log("submit");
  };

  function capitalizeAndSeparateWords(str) {
    let capitalizedString = str.charAt(0).toUpperCase() + str.slice(1);
    let separatedString = capitalizedString.replace(/([a-z])([A-Z])/g, "$1 $2");
    return separatedString;
  }

  const fields = [
    {
      Component: Input,
      name: "Record Audio",
      title: "Record Audio",
      type: "file",
      onChange: (event) => handleChange(event.target),
    },
  ];

  return (
    <div>
      <Style.MainHeading>
        {/* <Style.HeaderImg
          src={AudioVideoImg}
          alt="AudioVideoImg"
        ></Style.HeaderImg> */}
        Audio/Video Messages{" "}
        <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon>
      </Style.MainHeading>
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Audio Video Message</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              Plan Creators can leave one or more custom messages in audio or
              video format. Messages can be easily updated by Plan Creator and
              only viewable by others upon plan activation . The Trusted
              Individuals cannot alter the Plan Creators messages after death so
              that their wishes and intentions are protected. Serious: These can
              be highly serious and deeply confidential messages and the people
              who created this program realized the importance of potential
              grief counseling and other emotional support.
              {readMore && extraContent}
              <a
                onClick={() => {
                  setReadMore(!readMore);
                }}>
                <strong>{readMore ? " Read Less" : " Read More"}</strong>
              </a>
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>

      <Modal closable={false} visible={showModal} centered footer={false}>
        <div>
          <h3>
            {" "}
            Record {currentType && capitalizeAndSeparateWords(currentType)}
          </h3>
          <div style={{ display: "flex" }}>
            <img
              style={{ marginTop: "8px" }}
              src={RecordImg}
              width={"30.24px"}
              height={"30.24px"}
              alt="img"></img>
            <AudioReactRecorder
              state={recordState}
              onStop={onStop}
              backgroundColor="rgb(255,255,255)"
              foregroundColor="#2A3DA3"
              canvasHeight={"48px"}
              canvasWidth={"450px"}
            />
          </div>
          <div style={{ marginTop: "1rem" }}>
            <Upload
              onRemove={(e) => {
                console.log(e);
              }}
              // style={{ display: "none" }}
              showUploadList={false}
              customRequest={({ file, onError, onSuccess, onProgress }) => {
                HandleAudioUpload({ file, onError, onSuccess, onProgress });
              }}>
              {" "}
              <Style.FileLabel
                htmlFor="file-input"
                style={{ width: "100%" }}
                // className="file"
              >
                <Style.FileBlock id="filechose" style={{ marginRight: "10px" }}>
                  {fileName ? fileName : "No file Choosen"}{" "}
                  <img src={fileIcon} alt="fileIcon"></img>
                </Style.FileBlock>
                <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
              </Style.FileLabel>
            </Upload>
          </div>
          {/*  {audioData && audioData.url && (
            <audio
              id="audio"
              controls
              src={audioData ? audioData.url : null}
            ></audio>
        )} */}
          <Style.RecordingButtons>
            <Style.StopButton
              id="stop"
              onClick={() => {
                stop();
                setRecordState(null);
                handelCloseModal();
              }}>
              Cancel
            </Style.StopButton>
            {recordState !== null ? (
              <Style.RecordButton id="stop" onClick={stop}>
                Stop and Upload
              </Style.RecordButton>
            ) : (
              <Style.RecordButton id="record" onClick={start}>
                Start
              </Style.RecordButton>
            )}
          </Style.RecordingButtons>
        </div>
        <Loader isLoading={loading} />
      </Modal>
      <Modal closable={false} visible={showVideoModal} centered footer={false}>
        <div>
          <h3>
            {" "}
            Record {currentType && capitalizeAndSeparateWords(currentType)}{" "}
          </h3>
          <WebcamStreamCapture
            create={(type, url) => {
              // setAudioVideo({
              //   ...JSON.parse(JSON.stringify(audioVideo)),
              //   [type]: url,
              // });
              // setAudioVideo((prev) => ({
              //   ...prev,
              //   [type]: url,
              // }));
              let obj = {
                ...audioVideo,
                [type]: url,
                [type + "Date"]: new Date(),
              };
              setAudioVideo(obj);
              console.log("spouseVideo", type, url);
              // this.setState({
              //   audio_video: {
              //     ...JSON.parse(JSON.stringify(this.state.audio_video)),
              //     [type]: url,
              //   },
              // });
              updateRecord(obj);
            }}
            currentType={currentType}
            onCancel={() => {
              setShowVideoModal(false);
            }}></WebcamStreamCapture>
        </div>
      </Modal>
      {currentType && (
        <Modal closable={false} centered visible={viewVideo} footer={false}>
          <h3>
            {" "}
            Watch {currentType && capitalizeAndSeparateWords(currentType)}
          </h3>
          {console.log("viewModal video ", audioVideo[`${currentType}Video`])}
          <div
            style={{
              display: "flex",
              height: "fit-content",
              margin: "auto",
              width: "20rem",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <video style={{ height: "20rem", width: "20rem" }} controls>
              <source
                src={currentType && audioVideo && audioVideo[currentType]}
                type="video/mp4"
              />
            </video>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "8px",
            }}>
            <Style.CancelButton
              onClick={() => {
                setCurrentType(null);
                setViewVideo(false);
              }}>
              Close
            </Style.CancelButton>
          </div>
        </Modal>
      )}
      <Modal closable={false} centered visible={viewAudio} footer={false}>
        <h3>
          {" "}
          Listen {currentType && capitalizeAndSeparateWords(currentType)}
        </h3>
        <div
          style={{
            display: "flex",
            height: "fit-content",
            margin: "auto",
            width: "20rem",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <audio style={{ height: "20rem", width: "20rem" }} controls>
            <source
              src={currentType && audioVideo && audioVideo[currentType]}
              type="audio/mpeg"
            />
          </audio>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "8px",
          }}>
          <Style.CancelButton
            onClick={() => {
              setCurrentType(null);
              setViewAudio(false);
            }}>
            Close
          </Style.CancelButton>
        </div>
      </Modal>
      <Style.HeaderCard>
        <Style.HeaderCardHeading>SPOUSE</Style.HeaderCardHeading>
        <Style.HeaderCardHeadingB>FAMILY</Style.HeaderCardHeadingB>
        <Style.HeaderCardHeadingB>FRIENDS</Style.HeaderCardHeadingB>
      </Style.HeaderCard>
      <Style.AudioVideoCardSection>
        <Style.AudioVideoCards>
          {/* Spouse Audio Video Cards */}
          <Style.SubCard>
            <Style.SubCardHeader>
              <Style.Title style={{}}>Audio Message</Style.Title>
              {props.role !== "protrustee" && (
                <div>
                  <Style.Button
                    onClick={() => {
                      setShowModal(true);
                      setCurrentType("spouseAudio");
                    }}>
                    +
                  </Style.Button>
                </div>
              )}
            </Style.SubCardHeader>
            <div>
              {audioVideo &&
              audioVideo.hasOwnProperty(`${"spouse"}Audio`) &&
              audioVideo[`${"spouse"}Audio`] ? (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>
                    <a
                      style={{ color: "#6b7a99" }}
                      href={audioVideo[`${"spouse"}Audio`]}
                      target="blank">
                      Audio
                    </a>
                    <div>
                      {audioVideo[`${"spouse"}AudioDate`] &&
                        moment(audioVideo[`${"spouse"}AudioDate`]).format(
                          "MM-DD-YYYY"
                        )}
                    </div>
                    <img
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      src={SeeMore}
                      alt="seemore"
                      onClick={() => {
                        console.log("name of clicked");
                        setCurrentType("spouseAudio");
                        setDropdown(!dropdown);
                      }}></img>
                    {dropdown &&
                      audioVideo[`${"spouse"}Audio`] &&
                      currentType === "spouseAudio" && (
                        <>
                          <div
                            onClick={() => {
                              setDropdown(false);
                            }}
                            className=""
                            style={{
                              position: "fixed",
                              width: "100vw",
                              height: "100vh",
                              background: "black",
                              opacity: "0.1",
                              top: "0",
                              left: "0",
                              right: "0",
                              bottom: "0",
                              zIndex: "999",
                            }}></div>

                          <div class="dropdownAudio" style={{ zIndex: "9999" }}>
                            <ul className="dropdownul">
                              {props.role !== "protrustee" && (
                                <li
                                  className="liHover"
                                  onClick={() => {
                                    setDropdown(false);
                                    swal({
                                      title: "Are you sure?",
                                      text: "Are you sure you want to delete this media file?",
                                      dangerMode: true,
                                      buttons: [
                                        "No, cancel it!",
                                        "Yes, delete it!",
                                      ],
                                      icon: "warning",
                                      type: "warning",
                                      closeOnConfirm: false,
                                      closeOnCancel: false,
                                    }).then(function (isConfirm) {
                                      // Redirect the user
                                      if (isConfirm) {
                                        setLoading(true);
                                        let obj = {
                                          ...audioVideo,
                                          [`${"spouse"}Audio`]: null,
                                        };
                                        setAudioVideo(obj);
                                        setTimeout(async () => {
                                          await updateRecord(obj);
                                          setLoading(false);
                                          swal(
                                            "Deleted!",
                                            "Your file has been deleted.",
                                            "success"
                                          );
                                        }, 0);
                                      } else {
                                        swal(
                                          "Cancelled",
                                          "Your file is safe :)",
                                          "error"
                                        );
                                      }
                                    });
                                  }}>
                                  Delete
                                </li>
                              )}
                              <li
                                className="liHover"
                                onClick={() => {
                                  setDropdown(false);
                                  setViewAudio(true);
                                }}>
                                View
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                  </Style.FileTitle>
                </Style.FileHeader>
              ) : (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>No Media</Style.FileTitle>
                </Style.FileHeader>
              )}
            </div>
          </Style.SubCard>
          <Style.SubCard>
            <Style.SubCardHeader>
              <Style.Title style={{}}>Video Message</Style.Title>
              {props.role !== "protrustee" && (
                <div>
                  <Style.Button
                    onClick={() => {
                      setShowVideoModal(true);
                      setCurrentType("spouseVideo");
                    }}>
                    +
                  </Style.Button>
                </div>
              )}
            </Style.SubCardHeader>
            <div>
              {audioVideo &&
              audioVideo.hasOwnProperty(`${"spouse"}Video`) &&
              audioVideo[`${"spouse"}Video`] ? (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>
                    <a
                      style={{ color: "#6b7a99" }}
                      href={audioVideo[`${"spouse"}Video`]}
                      target="blank">
                      Video
                    </a>
                    <div>
                      {audioVideo[`${"spouse"}VideoDate`] &&
                        moment(audioVideo[`${"spouse"}VideoDate`]).format(
                          "MM-DD-YYYY"
                        )}
                    </div>

                    <img
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      src={SeeMore}
                      alt="seemore"
                      onClick={() => {
                        console.log("name of clicked");
                        setCurrentType("spouseVideo");
                        setDropdown(!dropdown);
                      }}></img>
                    {dropdown &&
                      audioVideo[`${"spouse"}Video`] &&
                      currentType === "spouseVideo" && (
                        <>
                          <div
                            onClick={() => {
                              setDropdown(false);
                            }}
                            className=""
                            style={{
                              position: "fixed",
                              width: "100vw",
                              height: "100vh",
                              background: "black",
                              opacity: "0.1",
                              top: "0",
                              left: "0",
                              right: "0",
                              bottom: "0",
                              zIndex: "999",
                            }}></div>

                          <div class="dropdownAudio" style={{ zIndex: "9999" }}>
                            <ul className="dropdownul">
                              {props.role !== "protrustee" && (
                                <li
                                  className="liHover"
                                  onClick={() => {
                                    setDropdown(false);
                                    swal({
                                      title: "Are you sure?",
                                      text: "Are you sure you want to delete this media file?",
                                      dangerMode: true,
                                      buttons: [
                                        "No, cancel it!",
                                        "Yes, delete it!",
                                      ],
                                      icon: "warning",
                                      type: "warning",
                                      closeOnConfirm: false,
                                      closeOnCancel: false,
                                    }).then(function (isConfirm) {
                                      // Redirect the user
                                      if (isConfirm) {
                                        setLoading(true);
                                        let obj = {
                                          ...audioVideo,
                                          [`${"spouse"}Video`]: null,
                                        };
                                        setAudioVideo(obj);
                                        setTimeout(async () => {
                                          await updateRecord(obj);
                                          setLoading(false);
                                          swal(
                                            "Deleted!",
                                            "Your file has been deleted.",
                                            "success"
                                          );
                                        }, 0);
                                      } else {
                                        swal(
                                          "Cancelled",
                                          "Your file is safe :)",
                                          "error"
                                        );
                                      }
                                    });
                                  }}>
                                  Delete
                                </li>
                              )}
                              <li
                                className="liHover"
                                onClick={() => {
                                  setDropdown(false);
                                  setViewVideo(true);
                                }}>
                                View
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                  </Style.FileTitle>
                </Style.FileHeader>
              ) : (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>No Media</Style.FileTitle>
                </Style.FileHeader>
              )}
            </div>
          </Style.SubCard>
        </Style.AudioVideoCards>
        <Style.AudioVideoCards>
          {/* Family Audio Video Cards */}
          <Style.SubCard>
            <Style.SubCardHeader>
              <Style.Title style={{}}>Audio Message</Style.Title>
              {props.role !== "protrustee" && (
                <div>
                  <Style.Button
                    onClick={() => {
                      setShowModal(true);
                      setCurrentType("familyAudio");
                    }}>
                    +
                  </Style.Button>
                </div>
              )}
            </Style.SubCardHeader>
            <div>
              {audioVideo &&
              audioVideo.hasOwnProperty(`${"family"}Audio`) &&
              audioVideo[`${"family"}Audio`] ? (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>
                    <a
                      style={{ color: "#6b7a99" }}
                      href={audioVideo[`${"family"}Audio`]}
                      target="blank">
                      Audio
                    </a>
                    <div>
                      {audioVideo[`${"family"}AudioDate`] &&
                        moment(audioVideo[`${"family"}AudioDate`]).format(
                          "MM-DD-YYYY"
                        )}
                    </div>

                    <img
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      src={SeeMore}
                      alt="seemore"
                      onClick={() => {
                        console.log("name of clicked");
                        setDropdown(!dropdown);
                        setCurrentType("familyAudio");
                      }}></img>
                    {dropdown &&
                      audioVideo[`${"family"}Audio`] &&
                      currentType === "familyAudio" && (
                        <>
                          <div
                            onClick={() => {
                              setDropdown(false);
                            }}
                            className=""
                            style={{
                              position: "fixed",
                              width: "100vw",
                              height: "100vh",
                              background: "black",
                              opacity: "0.1",
                              top: "0",
                              left: "0",
                              right: "0",
                              bottom: "0",
                              zIndex: "999",
                            }}></div>

                          <div class="dropdownAudio" style={{ zIndex: "9999" }}>
                            <ul className="dropdownul">
                              {props.role !== "protrustee" && (
                                <li
                                  className="liHover"
                                  onClick={() => {
                                    setDropdown(false);
                                    swal({
                                      title: "Are you sure?",
                                      text: "Are you sure you want to delete this media file?",
                                      dangerMode: true,
                                      buttons: [
                                        "No, cancel it!",
                                        "Yes, delete it!",
                                      ],
                                      icon: "warning",
                                      type: "warning",
                                      closeOnConfirm: false,
                                      closeOnCancel: false,
                                    }).then(function (isConfirm) {
                                      // Redirect the user
                                      if (isConfirm) {
                                        setLoading(true);
                                        let obj = {
                                          ...audioVideo,
                                          [`${"family"}Audio`]: null,
                                        };
                                        setAudioVideo(obj);
                                        setTimeout(async () => {
                                          await updateRecord(obj);
                                          setLoading(false);
                                          swal(
                                            "Deleted!",
                                            "Your file has been deleted.",
                                            "success"
                                          );
                                        }, 0);
                                      } else {
                                        swal(
                                          "Cancelled",
                                          "Your file is safe :)",
                                          "error"
                                        );
                                      }
                                    });
                                  }}>
                                  Delete
                                </li>
                              )}
                              <li
                                className="liHover"
                                onClick={() => {
                                  setDropdown(false);
                                  setViewAudio(true);
                                }}>
                                View
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                  </Style.FileTitle>
                </Style.FileHeader>
              ) : (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>No Media</Style.FileTitle>
                </Style.FileHeader>
              )}
            </div>
          </Style.SubCard>
          <Style.SubCard>
            <Style.SubCardHeader>
              <Style.Title style={{}}>Video Message</Style.Title>
              {props.role !== "protrustee" && (
                <div>
                  <Style.Button
                    onClick={() => {
                      setShowVideoModal(true);
                      setCurrentType("familyVideo");
                    }}>
                    +
                  </Style.Button>{" "}
                </div>
              )}
            </Style.SubCardHeader>
            <div>
              {audioVideo &&
              audioVideo.hasOwnProperty(`${"family"}Video`) &&
              audioVideo[`${"family"}Video`] ? (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>
                    <a
                      style={{ color: "#6b7a99" }}
                      href={audioVideo[`${"family"}Video`]}
                      target="blank">
                      Video
                    </a>
                    <div>
                      {audioVideo[`${"family"}VideoDate`] &&
                        moment(audioVideo[`${"family"}VideoDate`]).format(
                          "MM-DD-YYYY"
                        )}
                    </div>

                    <img
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      src={SeeMore}
                      alt="seemore"
                      onClick={() => {
                        console.log("name of clicked");
                        setDropdown(!dropdown);
                        setCurrentType("familyVideo");
                      }}></img>
                    {dropdown &&
                      audioVideo[`${"family"}Video`] &&
                      currentType === "familyVideo" && (
                        <>
                          <div
                            onClick={() => {
                              setDropdown(false);
                            }}
                            className=""
                            style={{
                              position: "fixed",
                              width: "100vw",
                              height: "100vh",
                              background: "black",
                              opacity: "0.1",
                              top: "0",
                              left: "0",
                              right: "0",
                              bottom: "0",
                              zIndex: "999",
                            }}></div>

                          <div class="dropdownAudio" style={{ zIndex: "9999" }}>
                            <ul className="dropdownul">
                              {props.role !== "protrustee" && (
                                <li
                                  className="liHover"
                                  onClick={() => {
                                    setDropdown(false);
                                    swal({
                                      title: "Are you sure?",
                                      text: "Are you sure you want to delete this media file?",
                                      dangerMode: true,
                                      buttons: [
                                        "No, cancel it!",
                                        "Yes, delete it!",
                                      ],
                                      icon: "warning",
                                      type: "warning",
                                      closeOnConfirm: false,
                                      closeOnCancel: false,
                                    }).then(function (isConfirm) {
                                      // Redirect the user
                                      if (isConfirm) {
                                        setLoading(true);
                                        let obj = {
                                          ...audioVideo,
                                          [`${"family"}Video`]: null,
                                        };
                                        setAudioVideo(obj);
                                        setTimeout(async () => {
                                          await updateRecord(obj);
                                          setLoading(false);
                                          swal(
                                            "Deleted!",
                                            "Your file has been deleted.",
                                            "success"
                                          );
                                        }, 0);
                                      } else {
                                        swal(
                                          "Cancelled",
                                          "Your file is safe :)",
                                          "error"
                                        );
                                      }
                                    });
                                  }}>
                                  Delete
                                </li>
                              )}
                              <li
                                className="liHover"
                                onClick={() => {
                                  setDropdown(false);
                                  setViewVideo(true);
                                }}>
                                View
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                  </Style.FileTitle>
                </Style.FileHeader>
              ) : (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>No Media</Style.FileTitle>
                </Style.FileHeader>
              )}
            </div>
          </Style.SubCard>
        </Style.AudioVideoCards>{" "}
        <Style.AudioVideoCards>
          {/* Friends Audio Video Cards */}
          <Style.SubCard>
            <Style.SubCardHeader>
              <Style.Title style={{}}>Audio Message</Style.Title>
              {props.role !== "protrustee" && (
                <div>
                  <Style.Button
                    onClick={() => {
                      setShowModal(true);
                      setCurrentType("friendsAudio");
                    }}>
                    +
                  </Style.Button>{" "}
                </div>
              )}
            </Style.SubCardHeader>
            <div>
              {audioVideo &&
              audioVideo.hasOwnProperty(`${"friends"}Audio`) &&
              audioVideo[`${"friends"}Audio`] ? (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>
                    <a
                      style={{ color: "#6b7a99" }}
                      href={audioVideo[`${"friends"}Audio`]}
                      target="blank">
                      Audio
                    </a>
                    <div>
                      {audioVideo[`${"friends"}AudioDate`] &&
                        moment(audioVideo[`${"friends"}AudioDate`]).format(
                          "MM-DD-YYYY"
                        )}
                    </div>

                    <img
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      src={SeeMore}
                      alt="seemore"
                      onClick={() => {
                        console.log("name of clicked");
                        setDropdown(!dropdown);
                        setCurrentType("friendsAudio");
                      }}></img>
                    {dropdown &&
                      audioVideo[`${"friends"}Audio`] &&
                      currentType === "friendsAudio" && (
                        <>
                          <div
                            onClick={() => {
                              setDropdown(false);
                            }}
                            className=""
                            style={{
                              position: "fixed",
                              width: "100vw",
                              height: "100vh",
                              background: "black",
                              opacity: "0.1",
                              top: "0",
                              left: "0",
                              right: "0",
                              bottom: "0",
                              zIndex: "999",
                            }}></div>

                          <div class="dropdownAudio" style={{ zIndex: "9999" }}>
                            <ul className="dropdownul">
                              {props.role !== "protrustee" && (
                                <li
                                  className="liHover"
                                  onClick={() => {
                                    setDropdown(false);
                                    swal({
                                      title: "Are you sure?",
                                      text: "Are you sure you want to delete this media file?",
                                      dangerMode: true,
                                      buttons: [
                                        "No, cancel it!",
                                        "Yes, delete it!",
                                      ],
                                      icon: "warning",
                                      type: "warning",
                                      closeOnConfirm: false,
                                      closeOnCancel: false,
                                    }).then(function (isConfirm) {
                                      // Redirect the user
                                      if (isConfirm) {
                                        setLoading(true);
                                        let obj = {
                                          ...audioVideo,
                                          [`${"friends"}Audio`]: null,
                                        };
                                        setAudioVideo(obj);
                                        setTimeout(async () => {
                                          await updateRecord(obj);
                                          setLoading(false);
                                          swal(
                                            "Deleted!",
                                            "Your file has been deleted.",
                                            "success"
                                          );
                                        }, 0);
                                      } else {
                                        swal(
                                          "Cancelled",
                                          "Your file is safe :)",
                                          "error"
                                        );
                                      }
                                    });
                                  }}>
                                  Delete
                                </li>
                              )}
                              <li
                                className="liHover"
                                onClick={() => {
                                  setDropdown(false);
                                  setViewAudio(true);
                                }}>
                                View
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                  </Style.FileTitle>
                </Style.FileHeader>
              ) : (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>No Media</Style.FileTitle>
                </Style.FileHeader>
              )}
            </div>
          </Style.SubCard>
          <Style.SubCard>
            <Style.SubCardHeader>
              <Style.Title style={{}}>Video Message</Style.Title>
              {props.role !== "protrustee" && (
                <div>
                  <Style.Button
                    onClick={() => {
                      setShowVideoModal(true);
                      setCurrentType("friendsVideo");
                    }}>
                    +
                  </Style.Button>{" "}
                </div>
              )}
            </Style.SubCardHeader>
            <div>
              {audioVideo &&
              audioVideo.hasOwnProperty(`${"friends"}Video`) &&
              audioVideo[`${"friends"}Video`] ? (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>
                    <a
                      style={{ color: "#6b7a99" }}
                      href={audioVideo[`${"friends"}Video`]}
                      target="blank">
                      Video
                    </a>
                    <div>
                      {audioVideo[`${"friends"}VideoDate`] &&
                        moment(audioVideo[`${"friends"}VideoDate`]).format(
                          "MM-DD-YYYY"
                        )}
                    </div>

                    <img
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      src={SeeMore}
                      alt="seemore"
                      onClick={() => {
                        console.log("name of clicked");
                        setDropdown(!dropdown);
                        setCurrentType("friendsVideo");
                      }}></img>
                    {dropdown &&
                      audioVideo[`${"friends"}Video`] &&
                      currentType === "friendsVideo" && (
                        <>
                          <div
                            onClick={() => {
                              setDropdown(false);
                            }}
                            className=""
                            style={{
                              position: "fixed",
                              width: "100vw",
                              height: "100vh",
                              background: "black",
                              opacity: "0.1",
                              top: "0",
                              left: "0",
                              right: "0",
                              bottom: "0",
                              zIndex: "999",
                            }}></div>

                          <div class="dropdownAudio" style={{ zIndex: "9999" }}>
                            <ul className="dropdownul">
                              {props.role !== "protrustee" && (
                                <li
                                  className="liHover"
                                  onClick={() => {
                                    setDropdown(false);
                                    swal({
                                      title: "Are you sure?",
                                      text: "Are you sure you want to delete this media file?",
                                      dangerMode: true,
                                      buttons: [
                                        "No, cancel it!",
                                        "Yes, delete it!",
                                      ],
                                      icon: "warning",
                                      type: "warning",
                                      closeOnConfirm: false,
                                      closeOnCancel: false,
                                    }).then(function (isConfirm) {
                                      // Redirect the user
                                      if (isConfirm) {
                                        setLoading(true);
                                        let obj = {
                                          ...audioVideo,
                                          [`${"friends"}Video`]: null,
                                        };
                                        setAudioVideo(obj);
                                        setTimeout(async () => {
                                          await updateRecord(obj);
                                          setLoading(false);
                                          swal(
                                            "Deleted!",
                                            "Your file has been deleted.",
                                            "success"
                                          );
                                        }, 0);
                                      } else {
                                        swal(
                                          "Cancelled",
                                          "Your file is safe :)",
                                          "error"
                                        );
                                      }
                                    });
                                  }}>
                                  Delete
                                </li>
                              )}
                              <li
                                className="liHover"
                                onClick={() => {
                                  setDropdown(false);
                                  setViewVideo(true);
                                }}>
                                View
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                  </Style.FileTitle>
                </Style.FileHeader>
              ) : (
                <Style.FileHeader>
                  <Style.FileTitle style={{}}>No Media</Style.FileTitle>
                </Style.FileHeader>
              )}
            </div>
          </Style.SubCard>
        </Style.AudioVideoCards>
      </Style.AudioVideoCardSection>

      <div style={{ margin: "1rem 0", }}>
      <Collapse>
        <Panel header={"Third Party Resources"}>
        <div
        style={{
          display: "flex",
          background: "white",
          borderRadius: "8px",
          overflow: "hidden",
          marginTop: "1rem",
          justifyContent: "space-between",
        }}>
        {/* Professional Resources question */}
        <div style={{ width: "47%", overflow: "hidden" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // gap: "4px",
              justifyContent: "center",
            }}>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: "500",
                textAlign: "center",
                color: "#1c1c1c",
                marginTop: "1rem",
              }}>
              Professional Resources
            </p>
            <Style.HelpIcon
              src={helpIcon}
              alt="helpicon"
              onClick={() => {
                handleResourcesVideo();
              }}></Style.HelpIcon>
          </div>

         {/* <AdsContainer images={imageList} name={"AudioVideo"} /> */}
          <CarouselContainer images={imageList} name={"AudioVideo"} />
        </div>

        <div style={{ width: "47%", overflow: "hidden" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // gap: "4px",
              justifyContent: "center",
            }}>
            <p
              style={{
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: "500",
                textAlign: "center",
                color: "#1c1c1c",
                marginTop: "1rem",
              }}>
              Self-Help Resources
            </p>
            <Style.HelpIcon
              src={helpIcon}
              alt="helpicon"
              onClick={() => {
                handleResourcesVideo();
              }}></Style.HelpIcon>
          </div>

          {/* modal */}
          <Modal
            centered
            visible={handleResouceVideoModal}
            footer={null}
            onCancel={handleCancelResourcesVideo}>
            <Style.ModalTitle style={{ textAlign: "center" }}>
              {" "}
              {/* Resource Video */}
            </Style.ModalTitle>
            <div style={{}}>
              <div
                style={{
                  display: "flex",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                {handleResouceVideoModal && (
                  <video style={{ width: "25rem", margin: "20px" }} controls>
                    <source
                      src={
                        "https://assets-planet.s3.amazonaws.com/media/db230a8f-2308-4111-8ee9-aec0ee2c33a2.mp4"
                      }
                      type="video/mp4"
                    />
                  </video>
                )}
              </div>
            </div>
          </Modal>
        
          {/*<AdsContainer images={imageList1} name={"AudioVideo"} />*/}
          <CarouselContainer images={imageList1} name={"AudioVideo"} />

        </div>
      </div>
        </Panel>
      </Collapse>
    </div>

      
      <Loader isLoading={loading} />
    </div>
  );
};
